import { css } from "styled-components";

const HeadlineStyle = css`
  font-family: ${({ theme }) => theme.fonts.graphik};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray1200};
  font-size: 2.625rem;
  line-height: 110%;
  letter-spacing: -2%;
  ${({ theme }) => theme.media.tabletUp`
    font-size: 3.625rem;
    line-height: 100%;
  `};
  ${({ theme }) => theme.media.desktopUp`
    font-size: 3rem;
  `};
`;

export default HeadlineStyle;
